<SettingsLayout page='settings' label="{"Settings"}">
  <h1>{"Settings"}</h1>

  <SettingsList>
    <SettingsListRow>
      <SettingsListButton href="/settings/general" label="{"General"}"/>
    </SettingsListRow>
    <SettingsListRow>
      {#if singleInstance}
        <SettingsListButton href="/settings/account" label="{"Account"}"/>
      {:else}
        <SettingsListButton href="/settings/instances" label="{"Instances"}"/>
      {/if}
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/hotkeys" label="{"Hotkeys"}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/about" label="{"About Enafore"}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="/settings/logs" label="{"Logs"}"/>
    </SettingsListRow>
    <SettingsListRow>
      <SettingsListButton href="#" on:click="reload(event)" label="{"Reload"}"/>
    </SettingsListRow>
  </SettingsList>

</SettingsLayout>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import SettingsList from '../../_components/settings/SettingsList.html'
  import SettingsListRow from '../../_components/settings/SettingsListRow.html'
  import SettingsListButton from '../../_components/settings/SettingsListButton.html'

  export default {
    components: {
      SettingsLayout,
      SettingsList,
      SettingsListRow,
      SettingsListButton
    },
    methods: {
      async reload (event) {
        event.preventDefault()
        try {
          await Promise.all((await navigator.serviceWorker.getRegistrations()).map(e => e.unregister()))
        } catch (e) {
          console.error(e)
        }
        document.location.reload(true)
      }
    },
    data: () => ({
      singleInstance: process.env.SINGLE_INSTANCE
    })
  }
</script>
